import {PersonResponseBodyV2} from '@dms/api/customer';
import {BankAccountRequestBody, CustomFieldValue} from '@dms/api/shared';

import {BusinessInfo} from './BusinessInfo';
import type {LegalFormEnum} from './LegalFormEnum';

export type ContractInformation = {
  id: string;
  permanent: boolean;
  legalForm: LegalFormEnum;
  bankAccounts: Array<BankAccountRequestBody>;
  person: PersonResponseBodyV2 | null;
  businessInfo: BusinessInfo | null;
  customFieldsPayload: CustomFieldValue[];
};
